import { useSyncExternalStore } from "react";
import {
  getMotionPref,
  isReducedActive,
  setMotionPref,
  subscribe,
  type MotionPref,
} from "@/lib/motionPreference";

/**
 * React access to the global motion preference.
 * `pref` is the user's stored choice; `reduced` is the effective value
 * (taking the OS setting into account) used to gate JS-driven animations.
 */
export function useMotionPreference() {
  const pref = useSyncExternalStore(
    subscribe,
    getMotionPref,
    () => "system" as MotionPref,
  );
  const reduced = useSyncExternalStore(subscribe, isReducedActive, () => false);
  return { pref, reduced, setPref: setMotionPref };
}
